import { NoSearchResultsFound } from "@similarweb/ui-components";

import { StyledNoSearchResultsFound } from "./styles";

const NoSearchResults = ({ searchTerm, className }: { searchTerm: string; className?: string }) => {
    return (
        <StyledNoSearchResultsFound className={className}>
            <NoSearchResultsFound searchTerm={searchTerm} />
        </StyledNoSearchResultsFound>
    );
};

export default NoSearchResults;
